import Vue from 'vue'
import Opinion from '../../enums/opinion'
import SpeakerState from '../../enums/speaker-state'
import MotionState from '../../enums/motion-state'
import SpeakersListLayout from '../../enums/speakers_list_layout'

export default{
  namespaced: true,
  state: {
    all: [],
    current: null,
    updateUiImmediately: true,
    showSpeakersOnScreen: true,
    speakersListLayout: SpeakersListLayout.CAROUSEL,
    showSpeakersOnScreenTwo: true,
    speakersListTwoLayout: SpeakersListLayout.CAROUSEL
  },
  getters: {
    all: state => state.all,
    inOrder: state => {
      return state.all.sort((a, b) => {
        if (!a.hasSession()) {
          return 0
        }
        if (!b.hasSession()) {
          return 0
        }
        return a.session.isBefore(b.session) ? -1 : 1
      })
    },
    forSession: state => (session) => {
      return state.all.filter((motion) => motion.hasSession() && motion.session.id === session.id)
    },
    getById: state => (id) => {
      return state.all.filter((motion) => motion.id === id)[0]
    },
    current: (state) => state.current,
    showSpeakersOnScreen: (state) => state.showSpeakersOnScreen,
    speakersListLayout: (state) => state.speakersListLayout,
    showSpeakersOnScreenTwo: (state) => state.showSpeakersOnScreenTwo,
    speakersListTwoLayout: (state) => state.speakersListTwoLayout
  },
  mutations: {
    SET_ALL (state, motions) {
      state.all = motions
    },
    SET_CURRENT (state, motion) {
      state.current = motion
    },
    CLEAR_CURRENT (state) {
      state.current = null
    },
    UPDATE (state, motion) {
      const i = state.all.findIndex((m) => m.id === motion.id)
      if (i < 0) {
        return
      }
      Vue.set(state.all, i, motion)
    },
    UPDATE_SPEAKER_STATUS (state, data) {
      if (state.current && data.motion.id === state.current.id) {
        const opinions = data.speaker.opinion === Opinion.FOR ? state.current.for : state.current.against
        const i = opinions.findIndex((speaker) => speaker.id === data.speaker.id)
        if (i > -1) {
          opinions[i].status = data.status
        }
      }
    },
    UPDATE_PROP_STATUS (state, data) {
      if (state.current && data.motion.id === state.current.id) {
        if (data.type === 'proposer') {
          state.current.proposerState = data.status
        } else {
          state.current.seconderState = data.status
        }
      }
    },
    UPDATE_MOTION_STATE (state, data) {
      if (state.current && data.motion.id === state.current.id) {
        state.current.state = data.state
        if (data.reason) {
          state.current.stateReason = data.reason
        }
      }
      const i = state.all.findIndex((motion) => motion.id === data.motion.id)
      if (i > -1) {
        state.all[i].state = data.state
        if (data.reason) {
          state.all[i].stateReason = data.reason
        }
      }
    },
    SET_SHOW_SPEAKERS_ON_SCREEN (state, show) {
      state.showSpeakersOnScreen = show
    },
    SET_SPEAKERS_LIST_LAYOUT (state, layout) {
      console.log('setting layout')
      state.speakersListLayout = layout
    },
    SET_SHOW_SPEAKERS_ON_SCREEN_TWO (state, show) {
      state.showSpeakersOnScreenTwo = show
    },
    SET_SPEAKERS_LIST_TWO_LAYOUT (state, layout) {
      state.speakersListTwoLayout = layout
    }
  },
  actions: {
    initPusher ({dispatch}) {
      this.$channels.screen.bind('motion-state-changed', (payload) => {
        dispatch('motionStateChanged', payload)
      })
      this.$channels.screen.bind('motion-started', (payload) => {
        dispatch('started', payload)
      })
      this.$channels.screen.bind('motion-updated', (payload) => {
        console.log('updating motion')
        console.log(payload)
        dispatch('loadOne', payload.motion.id)
      })
      this.$channels.screen.bind('motion-randomised', (payload) => {
        dispatch('loadOne', payload.motion.id)
      })
      this.$channels.screen.bind('speaker-started', (payload) => {
        dispatch('speakerStarted', payload)
      })
      this.$channels.screen.bind('speaker-finished', (payload) => {
        dispatch('speakerFinished', payload)
      })
      this.$channels.screen.bind('speaker-withdrawn', (payload) => {
        dispatch('speakerWithdrawn', payload)
      })
      this.$channels.screen.bind('prop-started', (payload) => {
        dispatch('propStarted', payload)
      })
      this.$channels.screen.bind('prop-finished', (payload) => {
        dispatch('propFinished', payload)
      })
    },
    async load ({commit}, extra = {}) {
      const motions = await this.$api.getMotions(extra)
      commit('SET_ALL', motions)
    },
    async loadOne ({commit}, id) {
      const motion = await this.$api.getMotion(id)
      commit('UPDATE', motion)
    },
    async loadCurrent ({commit}) {
      const motion = await this.$api.getCurrentMotion()
      if (motion) {
        commit('SET_CURRENT', motion)
      }
    },
    async started ({commit, dispatch}, payload) {
      console.log('motion started')
      commit('UPDATE_MOTION_STATE', Object.assign({}, payload, {state: MotionState.ACTIVE}))
      dispatch('loadCurrent')
    },
    async motionStateChanged ({commit, dispatch}, payload) {
      console.log('motion state change')
      console.log(payload)
      commit('UPDATE_MOTION_STATE', payload)
    },
    async speakerStarted ({commit}, payload) {
      console.log('speaker started')
      console.log(payload)
      commit('UPDATE_SPEAKER_STATUS', Object.assign(payload, {status: SpeakerState.ACTIVE}))
    },
    async speakerFinished ({commit}, payload) {
      console.log('speaker finished')
      console.log(payload)
      commit('UPDATE_SPEAKER_STATUS', Object.assign(payload, {status: SpeakerState.SPOKEN}))
    },
    async speakerWithdrawn ({commit}, payload) {
      console.log('speaker withdrawn')
      console.log(payload)
      commit('UPDATE_SPEAKER_STATUS', Object.assign(payload, {status: SpeakerState.WITHDRAWN}))
    },
    async propStarted ({commit}, payload) {
      console.log('prop started')
      console.log(payload)
      commit('UPDATE_PROP_STATUS', Object.assign(payload, {status: SpeakerState.ACTIVE}))
    },
    async propFinished ({commit}, payload) {
      console.log('prop finished')
      console.log(payload)
      commit('UPDATE_PROP_STATUS', Object.assign(payload, {status: SpeakerState.SPOKEN}))
    },
    async speakerStart ({commit, state}, speaker) {
      console.log('starting speaker')
      if (state.updateUiImmediately) {
        console.log('doing immediate update')
        commit('UPDATE_SPEAKER_STATUS', {
          motion: state.current,
          speaker: speaker,
          status: SpeakerState.ACTIVE
        })
      } else {
        console.log('not doing immediate update')
      }
      this.$api.speakerSpeak(speaker)
    },
    async speakerFinish ({commit, state}, speaker) {
      if (state.updateUiImmediately) {
        commit('UPDATE_SPEAKER_STATUS', {
          motion: state.current,
          speaker: speaker,
          status: SpeakerState.SPOKEN
        })
      }
      await this.$api.speakerFinish(speaker)
    },
    async speakerWithdraw ({commit, state}, speaker) {
      console.log('withdrawing, in store')
      if (state.updateUiImmediately) {
        commit('UPDATE_SPEAKER_STATUS', {
          motion: state.current,
          speaker: speaker,
          status: SpeakerState.WITHDRAWN
        })
      }
      await this.$api.speakerWithdraw(speaker)
    },
    async propStart ({commit, state}, type) {
      if (state.updateUiImmediately) {
        commit('UPDATE_PROP_STATUS', {
          motion: state.current,
          type: type,
          status: SpeakerState.ACTIVE
        })
      }
      await this.$api.propSpeak(type)
    },
    async propFinish ({commit, state}, type) {
      if (state.updateUiImmediately) {
        commit('UPDATE_PROP_STATUS', {
          motion: state.current,
          type: type,
          status: SpeakerState.SPOKEN
        })
      }
      await this.$api.propFinish(type)
    },
    async changeState ({commit, state}, {status, reason}) {
      if (state.updateUiImmediately) {
        commit('UPDATE', Object.assign({}, state.current, {
          status: status,
          reason: reason
        }))
      }
      await this.$api.changeCurrentMotionState(status, reason)
    },
    async pass ({dispatch}, reason = null) {
      return dispatch('changeState', {status: MotionState.PASSED, reason: reason})
    },
    async hold ({dispatch}, reason = null) {
      return dispatch('changeState', {status: MotionState.HOLD, reason: reason})
    },
    async withdraw ({dispatch}, reason = null) {
      return dispatch('changeState', {status: MotionState.WITHDRAWN, reason: reason})
    },
    async temp ({commit}) {
      console.log('MOTIONS TEMP')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/motions.js